export const provinceOptions = [
  'MB',
  'ON',
  'BC',
  'AB',
  'SK',
  'NS',
  'NB',
  'NL',
  'PE',
  'QC',
  'YT',
  'NT',
  'NU',
];

export type SigningAuthorityOption = {
  label: string;
  value: string;
  disabled?: boolean;
};

export type SigningAuthorityOptionGroup = {
  group: string;
  items: SigningAuthorityOption[];
};

export const healthcardSigningAuthorityOptions: SigningAuthorityOptionGroup[] =
  [
    {
      group: 'Public',
      items: provinceOptions.map((province) => ({
        label: province,
        value: province,
      })),
    },
    {
      group: 'Private',
      items: [
        { label: 'MSH', value: 'MSH' },
        { label: 'QDOC', value: 'QDOC' },
      ],
    },
    {
      group: 'Federal',
      items: [
        { label: 'DND', value: 'DND' },
        { label: 'IFHP', value: 'IFHP' },
      ],
    },
  ];
